import React from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { WidgetProperties } from '../types'
import { DASHBOARD_EDITOR_HIDDEN_BUTTON_ID, DASHBOARD_EDITOR_VISIBLE_BUTTON_ID } from 'src/Libs/qa/ids'
import VisibilityIcon from 'src/Elements/VisibilityIcon'

interface StyleProps {
  disabled: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, { disabled }) => ({
  widgetItem: {
    backgroundColor: disabled ? theme.palette.grey.grey09 : theme.palette.common.white,
    border: `1px solid ${theme.palette.shades.shade03}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
}))

/**
 * WidgetArea component for the dashboard editor
 */
const WidgetArea: React.FC<WidgetProperties> = ({ name, hidden, setHidden, disabled, dataQa }) => {
  const { classes } = useStyles({ disabled })

  const visibilityIconDataQaId = hidden ? DASHBOARD_EDITOR_HIDDEN_BUTTON_ID : DASHBOARD_EDITOR_VISIBLE_BUTTON_ID

  return (
    <Box className={classes.widgetItem} data-qa={dataQa}>
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <VisibilityIcon isHidden={hidden} isDisabled={disabled} onClick={() => setHidden(!hidden)} data-qa={visibilityIconDataQaId} />
        <Typography
          variant={'h3'}
          sx={{
            wordWrap: 'break-all',
            textAlign: 'center',
            hyphens: 'auto',
            overflowWrap: 'anywhere',
            ...(disabled ? { color: 'grey.grey03' } : {}),
          }}
        >
          {name}
        </Typography>
      </Box>
    </Box>
  )
}

export default WidgetArea
